<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:46:46
 * @LastEditTime: 2021-01-28 16:34:29
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\views\merchantCenter\merchantManage\index.vue
-->
<template>
  <div>
    <el-card v-loading="loading" shadow="never">
      <div slot="header" class="card-header">
        <span>商家信息</span>
        <el-button type="primary" @click="$router.push('/merchant/merchantManage/edit')">完善资料</el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="um-label">商家名称：</span>
          <span class="um-value">{{ baseInfo.merchantName || '-' }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">所属公司：</span>
          <span class="um-value">{{ baseInfo.merchantCompany || '-' }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="12">
          <span class="um-label">联系人：</span>
          <span class="um-value">{{ baseInfo.merchantContactPerson || '-' }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">联系方式：</span>
          <span class="um-value">{{ baseInfo.merchantContactDetails || '-' }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">地址：</span>
          <span class="um-value">{{ baseInfo.merchantAddress || '-' }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">商家描述：</span>
          <span class="um-value">{{ baseInfo.merchantDescription || '-' }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">营业执照：</span>
          <el-image
            v-for="(item,index) in baseInfo.merchantBusinessLicenseUrlList"
            :key="index"
            style="width: 100px; height: 100px; margin-left:10px"
            :src="item"
            :preview-src-list="baseInfo.merchantBusinessLicenseUrlList"
          />
          <!-- <span class="um-value">{{ baseInfo.merchantBusinessLicenseUrlList }}</span> -->
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">商家照片：</span>
          <el-image
            v-for="(item,index) in baseInfo.merchantDesignNoList"
            :key="index"
            style="width: 100px; height: 100px; margin-left:10px"
            :src="item"
            :preview-src-list="baseInfo.merchantDesignNoList"
          />
          <!-- <span class="um-value">{{ baseInfo.merchantDesignNoList }}</span> -->
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { merchantDetails } from '@/api/merchantCenter.js'
export default {
  name: 'MerchantMerchantManageEdit',
  data() {
    return {
      loading: false,
      baseInfo: {}
    }
  },
  created() {
    this.getMerchantDetails()
  },
  methods: {
    async getMerchantDetails() {
      try {
        this.loading = true
        const res = await merchantDetails()
        this.baseInfo = res.data.data
        this.loading = false
      } catch (e) {
        this.loading = false
        this.errorHandle(e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
